import { USER_ERROR_MESSAGE } from "../../global/utils/constants";

export const getErrorDetails = (error) => {
  const extensions = error?.graphQLErrors?.[0]?.extensions;
  return {
    duration: extensions?.duration,
    isUserError: extensions?.type === USER_ERROR_MESSAGE,
    message: extensions?.type === USER_ERROR_MESSAGE ? error?.message : null,
  };
};
